import React, { useRef, useEffect, useState } from 'react';
import globalRouter from './Routes/globalRouter';
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import 'dayjs/locale/es';
import { generateColors } from '@mantine/colors-generator';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';

// Fake Backend
import fakeBackend from './helpers/AuthType/fakeBackend';
import ModalLoading from './Components/General/Modal/ModalLoading';
import { LoadingProvider } from './Context/LoadingContext';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import {Icons} from '../src/utils/Icons'

// Activating fake backend
fakeBackend();

function App() {
	const navigate = useNavigate();
	const location = useLocation();
	const ref = useRef(null);
	const [colors, setColors] = useState();

	globalRouter.navigate = navigate;
	window.Icons = Icons;
	useEffect(() => {
		ref.current.continuousStart();

		return () => {
			if (ref.current) {
				ref.current.complete();
			}
		};
	}, [location]);
	
	useEffect(() => {
		const timeout = setTimeout(() => {
			ref.current?.complete();
		}, 400);

		return () => clearTimeout(timeout);
	}, []);

	const selectLayoutState = state => state.Layout;
	const selectLayoutProperties = createSelector(selectLayoutState, layout => ({
		layoutModeType: layout.layoutModeType,
	}));

	const selectSettingsState = state => state.Settings;
	const selectSettingsProperties = createSelector(
		selectSettingsState,
		settings => ({
			itemSettingsColor: settings.itemSettingsColor,
		})
	);

	const { layoutModeType } = useSelector(selectLayoutProperties);
	const { itemSettingsColor } = useSelector(selectSettingsProperties);

	useEffect(() => {
		if (itemSettingsColor) {
			let colors = {};
			if (itemSettingsColor.primary_color) {
				colors.primary_color = generateColors(
					itemSettingsColor.primary_color
				);
			}
			if (itemSettingsColor.secondary_color) {
				colors.secondary_color = generateColors(
					itemSettingsColor.secondary_color
				);
			}
			setColors(colors);
		}
	}, [itemSettingsColor]);

	return (
		<MantineProvider
			theme={{
				colorScheme: layoutModeType,
				colors,
				primaryColor: colors?.primary_color ? 'primary_color' : undefined,
				primaryShade: colors?.primary_color
					? colors?.primary_color.findIndex(
							color => color === itemSettingsColor.primary_color
					  )
					: undefined,
			}}
		>
			<DatesProvider
				settings={{
					locale: 'es',
					timezone: 'UTC',
				}}
			>
				<LoadingProvider>
					<React.Fragment>
						<LoadingBar
							color='var(--vz-secondary)'
							shadow={true}
							ref={ref}
						/>
						<Route />
						<ModalLoading />
					</React.Fragment>
				</LoadingProvider>
			</DatesProvider>
		</MantineProvider>
	);
}

export default App;
